import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, useForm } from 'react-hook-form';
import { buildAddressFormValues } from '../../../components/Address/address.utils';
import { useTranslation } from '../../translation/TranslationContext';
import { useSignUpContext } from '../SignUp.context';
import { StoreStepFormValues, buildStoreStepSchema } from '../storeStep.schema';
import { CreateAccountStore } from '../types/createAccount.types';

const useStoreStepForm = () => {
  const { translate } = useTranslation();
  const { state, handleCompleteStoreStep } = useSignUpContext();
  const { cnpj, store, location } = state;

  const isInternational = location?.code !== 'BR';

  const form = useForm<StoreStepFormValues>({
    resolver: zodResolver(
      buildStoreStepSchema({ translate, isInternational }),
    ) as Resolver<StoreStepFormValues>,
    defaultValues: {
      location: store?.location ?? location?.code ?? '',
      countryCode: store?.countryCode ?? location?.phone ?? '',
      phone: store?.phone ?? location?.phone ?? '',
      cpfcnpj: store?.cpfcnpj ?? cnpj ?? '',
      commercialName: store?.commercialName ?? '',
      companyName: store?.companyName ?? '',
      stateInscription: store?.stateInscription ?? '',
      email: store?.email ?? '',
      documentType: store?.documentType,
      address: buildAddressFormValues({ address: store?.address }).address,
    },
  });

  const handleChangeCountryCode = (dialCode: string) => form.setValue('countryCode', dialCode);

  const handleSave = form.handleSubmit((values) =>
    handleCompleteStoreStep(values as unknown as CreateAccountStore),
  );

  return {
    form,
    isInternational,
    handleSave,
    handleChangeCountryCode,
    isSubmitting: form.formState.isSubmitting,
  };
};

export default useStoreStepForm;
